import type { InputHTMLAttributes } from 'react';

type ToggleProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: string;
};

export function Toggle({ label, id, className = '', checked, ...rest }: ToggleProps) {
  const inputId = id ?? label.toLowerCase().replace(/\s+/g, '-');

  return (
    <label htmlFor={inputId} className={`flex cursor-pointer items-center gap-3 ${className}`}>
      <span className="relative inline-flex h-[22px] w-10 shrink-0 items-center rounded-full transition-colors">
        <input id={inputId} type="checkbox" checked={checked} className="peer sr-only" {...rest} />
        <span
          className={`absolute inset-0 rounded-full transition-colors ${
            checked ? 'bg-action-primary' : 'border border-border-strong bg-bg-surface-secondary'
          }`}
        />
        <span
          className={`relative size-4 rounded-full bg-bg-surface shadow transition-transform ${
            checked ? 'translate-x-[21px]' : 'translate-x-[3px]'
          }`}
        />
      </span>
      <span className="text-[13px] font-medium text-text-primary">{label}</span>
    </label>
  );
}
